/**
 * Created by Carsten Hibbeler on 07.02.2016.
 */

import LogicalLayerStore from './LogicalLayerStore';
import LayerDataSourceStore from './LayerDataSourceStore';
import MapConfigStore from './MapConfigStore';
import GeoJsonStore from './GeoJsonStore';


let geoJsonStoreInstance;

export function getGeoJsonStore(AppContext) {
    return geoJsonStoreInstance || (geoJsonStoreInstance = AppContext.createStore(GeoJsonStore));
}

let mapConfigStoreInstance;

export function getMapConfigStore(AppContext) {
    return mapConfigStoreInstance || (mapConfigStoreInstance = AppContext.createStore(MapConfigStore));
}

let logicalLayerStoreInstance;

export function getLogicalLayerStore(AppContext) {
    return logicalLayerStoreInstance || (logicalLayerStoreInstance = AppContext.createStore(LogicalLayerStore));
}

let layerDataSourceStoreInstance;

export function getLayerDataSourceStore(AppContext) {
    return layerDataSourceStoreInstance || (layerDataSourceStoreInstance = AppContext.createStore(LayerDataSourceStore));
}




// WEBPACK FOOTER //
// ./js/stores/StoreFactory.js